// Theme packs recolor the studio's accent. A light touch over the token
// system: we only override the accent family, never structural tokens, so a
// theme can never break contrast or legibility.

export interface ThemePack {
  accent: string;
  accentDeep: string;
}

const KEY = "bd.theme.pack";

export function applyThemePack(theme: ThemePack): void {
  const root = document.documentElement;
  root.style.setProperty("--rhodes", theme.accent);
  root.style.setProperty("--rhodes-deep", theme.accentDeep);
}

export function persistThemePack(theme: ThemePack): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(theme));
  } catch {
    /* private mode: the theme simply resets next load */
  }
}

export function clearThemePack(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  const root = document.documentElement;
  root.style.removeProperty("--rhodes");
  root.style.removeProperty("--rhodes-deep");
}

/** Restore a previously installed theme on load (called from app boot). */
export function restoreThemePack(): void {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) applyThemePack(JSON.parse(raw) as ThemePack);
  } catch {
    /* ignore */
  }
}
